import React from "react";

function TermsConditions() {
  return (
    <div className="terms-page container" style={{ paddingTop: "100px" }}>
      {/* --- Terms & Conditions --- */}
      <h2 className="mb-4">Terms & Conditions</h2>

      {/* 1. Scope */}
      <div className="terms-item mb-3">
        <strong>1. Scope</strong>
        <p>
          These Terms and Conditions apply to all services provided by{" "}
          <strong style={{ display: "inline" }}>
            House of Berechet Studio L.L.C.
          </strong>{" "}
          (“HoB Studio”) including creative, design, post-production, and
          one-time or subscription-based projects. By accessing this website or
          engaging HoB Studio’s services, the client agrees to these terms.
        </p>
      </div>

      {/* 2. Services */}
      <div className="terms-item mb-3">
        <strong>2. Services</strong>
        <p>HoB Studio provides:</p>
        <ul>
          <li>
            Video editing, animation, color grading, design, and creative
            production.
          </li>
          <li>
            Subscription-based credit systems for continuous content production.
          </li>
          <li>One-time custom projects as per written agreement.</li>
        </ul>
        <p>
          The scope, deliverables, and timeline are defined in each project
          agreement or subscription plan.
        </p>
      </div>

      {/* 3. Credits & Subscription System */}
      <div className="terms-item mb-3">
        <strong>3. Credits & Subscription System</strong>
        <ul>
          <li>
            Each subscription plan includes a defined number of credits per
            month, which correspond to project complexity and deliverables.
          </li>
          <li>
            Unused credits roll over for one month unless otherwise specified in
            the client’s plan.
          </li>
          <li>
            Credits have no cash value and cannot be exchanged or transferred.
          </li>
          <li>Add-on or over-limit projects are billed separately.</li>
          <li>
            Cancellations must be made before the renewal date; otherwise,
            billing for the next cycle will apply automatically.
          </li>
          <li>
            Refunds are not provided for partially used periods or unused
            credits.
          </li>
        </ul>
      </div>

      {/* 4. Payment Terms */}
      <div className="terms-item mb-3">
        <strong>4. Payment Terms</strong>
        <ul>
          <li>
            Payments are processed via{" "}
            <strong style={{ display: "inline" }}>bank transfer</strong> or{" "}
            <strong style={{ display: "inline" }}>Stripe</strong>, as indicated
            in the invoice.
          </li>
          <li>
            Work begins after payment confirmation unless otherwise agreed.
          </li>
          <li>
            Late or incomplete payments may result in temporary service
            suspension or delivery delays.
          </li>
          <li>
            All prices are stated in EUR (or CHF/USD where specified) and are
            exclusive of applicable taxes or fees.
          </li>
        </ul>
      </div>

      {/* 5. Intellectual Property */}
      <div className="terms-item mb-3">
        <strong>5. Intellectual Property</strong>
        <ul>
          <li>
            Full ownership and rights to final deliverables transfer to the
            client only after full payment.
          </li>
          <li>
            HoB Studio retains ownership of all project files, templates, and
            creative methods used to produce deliverables unless specifically
            transferred in writing.
          </li>
          <li>
            HoB Studio reserves the right to showcase completed work in its
            portfolio and marketing materials unless bound by a written NDA.
          </li>
          <li>
            Clients are responsible for ensuring that all materials (logos,
            footage, audio, fonts, etc.) provided are properly licensed and free
            from third-party claims.
          </li>
        </ul>
      </div>

      {/* 6. Confidentiality */}
      <div className="terms-item mb-3">
        <strong>6. Confidentiality</strong>
        <p>
          All client data, creative materials, and project information are
          treated as confidential and will not be shared with third parties
          without consent, except where required by law.
        </p>
      </div>

      {/* 7. Liability */}
      <div className="terms-item mb-3">
        <strong>7. Liability</strong>
        <p>
          HoB Studio shall not be liable for any indirect, incidental, or
          consequential damages resulting from project use or delays. Liability
          is limited to the total amount paid for the respective project or
          subscription period.
        </p>
      </div>

      {/* 8. Data Processing & Security */}
      <div className="terms-item mb-3">
        <strong>8. Data Processing & Security</strong>
        <p>
          Client data is handled in accordance with GDPR principles and
          applicable Kosovo law. Secure systems and professional tools are used
          to store and process project information.
        </p>
      </div>

      {/* 9. Termination */}
      <div className="terms-item mb-3">
        <strong>9. Termination</strong>
        <p>
          Either party may terminate ongoing agreements with written notice
          according to the contract’s terms. Any outstanding fees remain payable
          in full.
        </p>
      </div>

      {/* 10. Jurisdiction */}
      <div className="terms-item mb-3">
        <strong>10. Jurisdiction</strong>
        <p>
          These terms are governed by the laws of the Republic of Kosovo. The
          place of jurisdiction for all disputes arising from contractual
          relationships is Prishtina, Kosovo.
        </p>
      </div>

      {/* --- Privacy Policy --- */}
      <h2 className="mt-5 mb-4">Privacy Policy</h2>

      {/* 1. General Information */}
      <div className="terms-item mb-3">
        <strong>1. General Information</strong>
        <p>
          HoB Studio respects your privacy and is committed to protecting your
          personal data. This policy explains what data we collect, how we use
          it, and your rights under applicable law.
        </p>
      </div>

      {/* 2. Data We Collect */}
      <div className="terms-item mb-3">
        <strong>2. Data We Collect</strong>
        <ul>
          <li>
            Contact information (name, email, company, phone) through forms and
            inquiries.
          </li>
          <li>Billing and payment data for projects and subscriptions.</li>
          <li>
            Website analytics and usage data via{" "}
            <strong style={{ display: "inline" }}>Google Analytics</strong> to
            improve user experience.
          </li>
          <li>Project-related data through our internal CRM system.</li>
        </ul>
      </div>

      {/* 3. Purpose of Processing */}
      <div className="terms-item mb-3">
        <strong>3. Purpose of Processing</strong>
        <ul>
          <li>Process inquiries, manage projects, and deliver services.</li>
          <li>Handle billing, payment, and communication.</li>
          <li>Improve and personalize website experience through analytics.</li>
          <li>Comply with legal obligations and maintain business records.</li>
        </ul>
      </div>

      {/* 4. Legal Basis */}
      <div className="terms-item mb-3">
        <strong>4. Legal Basis</strong>
        <ul>
          <li>
            Performance of a contract or pre-contractual measures (Art. 6 (1)(b)
            GDPR)
          </li>
          <li>Legal obligations (Art. 6 (1)(c))</li>
          <li>
            Legitimate interests (Art. 6 (1)(f)) in improving services and
            security
          </li>
        </ul>
      </div>

      {/* 5. Data Storage & Retention */}
      <div className="terms-item mb-3">
        <strong>5. Data Storage & Retention</strong>
        <p>
          Your data is securely stored and retained only as long as necessary to
          fulfill contractual and legal obligations.
        </p>
      </div>

      {/* 6. Data Sharing */}
      <div className="terms-item mb-3">
        <strong>6. Data Sharing</strong>
        <p>
          Data may be shared with payment processors (e.g., Stripe), analytics
          providers (e.g., Google), or CRM systems used by HoB Studio. No
          personal data is sold or shared with unauthorized third parties.
        </p>
      </div>

      {/* 7. User Rights */}
      <div className="terms-item mb-3">
        <strong>7. User Rights</strong>
        <ul>
          <li>Access, correct, or delete your data.</li>
          <li>Object to processing or request restriction of use.</li>
          <li>Withdraw consent at any time by contacting info@hobstudio.tv.</li>
        </ul>
      </div>

      {/* 8. Security */}
      <div className="terms-item mb-3">
        <strong>8. Security</strong>
        <p>
          We apply strict technical and organizational measures to protect your
          data from unauthorized access, loss, or misuse.
        </p>
      </div>

      {/* 9. Updates */}
      <div className="terms-item mb-3">
        <strong>9. Updates</strong>
        <p>
          This Privacy Policy may be updated periodically to reflect new laws or
          business practices. The current version will always be available on
          our website.
        </p>
      </div>
    </div>
  );
}

export default TermsConditions;
